import { render } from "./statistics.vue?vue&type=template&id=500469a0"
const script = {}

import "./statistics.vue?vue&type=style&index=0&id=500469a0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__